// const APP_PDF_FILLER = 'pdfFiller';
// const APP_AIR_SLATE = 'airSlate';

const TYPE = {
  ACCESS: 'access',
  PAGES: 'pages',
  ERASE: 'erase',
  ATTRIBUTES: 'attributes',
  TOKEN: 'token',
  CHECKMARK: 'checkmark',
  RADIO: 'radio',
  TEXT: 'text',
  HOLD: 'hold',
  USERS: 'users',
  IMAGE: 'image',
  SOURCE: 'source',
  TRACK: 'track',
  SCENARIOS: 'scenarios',
  FEATURES: 'features',
  DEFAULTS: 'defaults',
  GUI: 'gui',
  EXPERIMENTS: 'experiments',
  STATISTICS: 'statistics',
  LOCALE: 'locale',
  SIGNATURE: 'signature',
  BLACKOUT: 'blackout',
  CANCEL: 'cancel',
  MODE: 'mode',
  NATIVE: 'native',
  RECOGNIZE: 'recognize',
  RESOLUTION: 'resolution',
  USER: 'user',
  COMMENT: 'comment',
  LIST: 'list',
  ADD: 'add',
  ERROR: 'error',
  DELETE: 'delete',
  PREVIEW: 'preview',
  SAVE: 'save',
  RESTORE: 'restore',
  UPDATE: 'update',
  PENDING: 'pending',
  AUTOFILL: 'autofill',
  EXTERNAL: 'external',
  ALERT: 'alert',
  TRIGGER: 'trigger',
};

module.exports = {
  METADATA_DEFAULTS: {
    VERSION: '2.12.0',
    DPI: 72,
  },
  // APP_PDF_FILLER,
  // APP_AIR_SLATE,
  // ALLOWED_APPS: [ APP_PDF_FILLER, APP_AIR_SLATE ],

  GROUP: {
    EDITOR: 'editor',
    DOCUMENT: 'document',
    TOOLS: 'tools',
    ROLES: 'roles',
    VERSIONS: 'versions',
    COLLABORATION: 'collaboration',
    IMAGES: 'images',
    SIGNATURES: 'signatures',
    OPERATIONS: 'operations',
    FONT: 'font',
    DEBUG: 'debug',
    USERS: 'users',
    MAPPING: 'mapping',
    VALIDATORS: 'validators',
    INTEGRATIONS: 'integrations',
  },

  TYPE,

  SUB_TYPE: {
    FORMULA: 'formula',
    NUMBER: 'number',
    LIST: 'list',
    DATE: 'date',
    IMAGE: 'image',
    TEXT: 'text',
    CURVE: 'curve',
    CONSTRUCTOR: 'constructor',
    COMMAND: 'command',
    PREVIEW: 'preview',
    CHANGE: 'change',
    INITIALS: 'initials',
    NONE: 'none',
    POINT: 'point',
    OVERLYING: 'overlying',
    CURRENT: 'current',
    PREVIOUS: 'previous',
    VERSION: 'version',
    IRS: 'irs',
    TOOLTIP: 'tooltip',
    FOCUS_OUT: 'focusOut',
  },

  EDITOR_MODE: {
    INIT: 'init',
    MAIN: 'main',
    CONSTRUCTOR: 'constructor',
    ATTRIBUTES: 'attributes',
    PAGES: 'pages',
    VERSIONS: 'versions',
    TRUEEDIT: 'trueedit',
    PENDING: 'pending',
  },

  VERSION: {
    SAVE: 'save',
  },

  ACCESS: {
    EDIT: 'edit',
    VIEW: 'view',
    BUSY: 'busy',
    DENIED: 'denied',
    REQUEST: 'request',
    CAN_RELOAD: 'can_reload',
    CAN_VIEW: 'can_view',
    STRONG_BUSY: 'strong_busy',
    SWITCH_ENV: 'switch_env',
  },

  FILLABLE_MODE: {
    NO_FIELDS: 'no_fields',
    FIELDS: 'fields',
    SIGNATURE_FIELDS: 'signature_fields',
  },

  PDF_STATUS: {
    /**
     * @param {String} point
     * @param {Object} data
     * @param {Function} cb
     */
    PENDING: 'PENDING',
    FINISHED: 'FINISHED',
    ERROR: 'ERROR',
    SOURCE_ERROR: 'PDF Source Error',
  },

  OPERATIONS_CANCEL: {
    CANCEL_BY_MODE: 'byMode',
    CANCEL_BY_ID: 'byId',
  },

  OWNER: {
    LOCAL_ID: 0,
  },

  UNIQUE_OPERATIONS: [
    TYPE.PAGES, TYPE.SOURCE, TYPE.MODE,
  ],

  WORKER_STATUS: {
    SUCCESS: 'success',
  },

  REMOTE: {
    VALIDATION_ERROR: 'fail',
  },
};
